import React, { useState } from "react";
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const loginWrapper = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
}
const form = {
    display: 'flex',
    flexDirection: 'column'
}

async function loginUser(credentials) {
    return fetch('/api/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(credentials)
    })
}

export const Login = ({onLoginSuccess}) => {
    const [username, setUsername] = useState();
    const [password, setPassword] = useState();
    const [loginFailed, setLoginFailed] = useState(false);
    const { t } = useTranslation();

    const handleSubmit = async e => {
        e.preventDefault();
        const response = await loginUser({
          username,
          password
        });
        if (response.ok) {
            setLoginFailed(false);
            onLoginSuccess();
        } else {
            setLoginFailed(true);
        }
    }

    return(
        <div style={loginWrapper}>
            <h1>{t("login_text")}</h1>
            <form style={form} onSubmit={handleSubmit}>
                <label>
                    <p>{t("login_username")}</p>
                    <input type="text" onChange={e => setUsername(e.target.value)} />
                </label>
                <label>
                    <p>{t("login_password")}</p>
                    <input type="password" onChange={e => setPassword(e.target.value)} />
                </label>
                {loginFailed && <p>{t("login_failed")}</p>}
                <div>
                    <button type="submit">{t("create_signtask_nav_login")}</button>
                </div>
            </form>
        </div>
    );
}

Login.propTypes = {
    onLoginSuccess: PropTypes.func.isRequired
}